export enum Screens {
  INIT = 'init',
  COLLECTION = 'collection',
  SETTINGS = 'settings',
}
